/* eslint-disable react/no-this-in-sfc */
import { Card } from "components";
import GKCharts from "components/GKCharts";
import Highcharts from "highcharts/highstock";
import { formatYAxisLabel } from "utils/helpers";
import { moneyCommaSeparator } from "utils/MathFunction";

interface Props {
  data: [number, number][];
  loading: boolean;
}

const HighChartLine = ({ data, loading }: Props) => {
  const options = {
    chart: {
      backgroundColor: "var(--white)",
      borderRadius: 5,
      type: "area",
      height: 500,
    },
    title: {
      text: `<h1 id="chart-title">Total Assets Under Management</h1>`,
      align: "left",
      style: {
        color: "var(--primary-900)",
        fontWeight: 600,
        fontSize: 18,
      },
    },
    yAxis: {
      opposite: false,
      gridLineColor: `var(--neutral-100)`,
      color: `var(--warning-700)`,
      labels: {
        formatter(this: any) {
          return formatYAxisLabel(this?.value);
        },
        style: {
          color: "var(--primary-900)",
          fontSize: "12px",
          fontWeight: "bold",
        },
      },
    },
    plotOptions: {
      series: {
        states: {
          hover: {
            enabled: false,
          },
        },
        animation: false,
        fillColor: {
          linearGradient: [0, 0, 0, 300],
          stops: [
            [0, Highcharts.getOptions().colors[0]],
            [
              1,
              Highcharts.color(Highcharts.getOptions().colors[0])
                .setOpacity(0)
                .get("rgba"),
            ],
          ],
        },
      },
    },
    tooltip: {
      formatter(this: any) {
        const formattedDate = Highcharts.dateFormat("%b %e, %Y", this.x);

        let content = `<b>${formattedDate}</b><br/>`;

        this.points.forEach((point: any) => {
          content += `<span style="color:${point.color}">\u25CF</span> ${
            point.series.name
          }: <b>${moneyCommaSeparator(point.y)}</b><br/>`;
        });

        return content;
      },
    },
    series: [
      {
        name: "Total Assets Under Management",
        data: data?.sort((a, b) => a[0] - b[0]) || [],
        tooltip: {
          valueDecimals: 2,
          pointFormatter(this: any) {
            return `<span style="color:${this.color}">\u25CF</span> ${
              this.series.name
            }: <b>${moneyCommaSeparator(this.y)}</b><br/>`;
          },
          formatter(this: any) {
            return `<b></b>`;
          },
        },
        color: "var(--primary-900)",
        borderColor: "var(--primary-900)",
        fillColor: {
          linearGradient: [0, 0, 0, 400],
          stops: [
            [0, "var(--primary-900)"],
            [
              1,
              Highcharts.color(Highcharts.getOptions().colors[0])
                .setOpacity(0)
                .get("rgba"),
            ],
          ],
        },
      },
    ],
  };

  return (
    <Card>
      <GKCharts
        constructorType="stockChart"
        chartOptions={options}
        rangeSelector
        loading={loading}
        navigator
      />
    </Card>
  );
};

export default HighChartLine;
